import { CrudModule } from "@/command/ccCrud";

export default function Marketing() {
  return (
    <CrudModule
      title="Marketing" subtitle="Campaigns, budget, spend and leads — live."
      module="marketing" endpoint="/cc/marketing/campaigns" entity="campaign" summaryPath="/cc/marketing/summary"
      columns={[["name", "Campaign"], ["channel", "Channel"], ["status", "Status", "badge"], ["budget", "Budget", "money"], ["spend", "Spend", "money"], ["leads", "Leads"]]}
      fields={[["name", "Campaign", "text"], ["channel", "Channel", "select", ["LinkedIn", "Email", "Search", "Social", "Events", "Content"]],
        ["status", "Status", "select", ["Planned", "Active", "Completed", "Paused"]], ["budget", "Budget (₹)", "number"], ["spend", "Spend (₹)", "number"], ["leads", "Leads", "number"],
        ["start_date", "Start date", "date"]]}
      defaults={{ status: "Planned", channel: "LinkedIn" }}
      kpis={(rows, s) => [
        { label: "Campaigns", value: s?.campaigns ?? rows.length },
        { label: "Active", value: s?.active ?? 0 },
        { label: "Total Spend", value: s?.spend ?? 0, prefix: "₹" },
        { label: "Leads", value: s?.leads ?? 0 },
      ]}
    />
  );
}
